// @flow

import { createSelector } from 'reselect'
import { getGradeLevels } from './manifest'
import {
  groupEnrollmentsByMasterCourses,
  mapMasterCourseEnrollmentsObject,
  mapCourseSectionPropToEnrollments
} from '../utils/courses'

const _getStudentReviews = (state: Object): Array<Object> => {
  return state.studentprofile.reviews.filter(r => {
    return r.self_assessment
  })
}

const _getJourneysGroupedByMasterCourse = ({
  state,
  excludeNonAcademicYearCourses
}) => {
  const gradeLevels = getGradeLevels(state)
  const academicYears = state.academicyears.items
  const frameworkSubjects = state.manifest.data.framework_subjects
  const mappedCourseEnrollments = mapCourseSectionPropToEnrollments(
    state.studentprofile.courses
  )
  const masterCourses = groupEnrollmentsByMasterCourses(mappedCourseEnrollments)

  const mapped = mapMasterCourseEnrollmentsObject({
    masterCourses,
    gradeLevels,
    academicYears,
    frameworkSubjects,
    excludeNonAcademicYearCourses
  })

  return mapped
}

export const getStudentReviews = createSelector(
  [_getStudentReviews],
  (studentReviews): Array<Object> => {
    return studentReviews
  }
)

export const getJourneysGroupedByMasterCourse = createSelector(
  [_getJourneysGroupedByMasterCourse],
  (masterCourses): Array<Object> => {
    return masterCourses
  }
)
